// extracted by mini-css-extract-plugin
export default {"content":"style_content__AVerV","withRightPanel":"style_withRightPanel__iuCwk","fullPageContent":"style_fullPageContent__pSTG5","loading":"style_loading__kUoEF"};